export default `
  fragment ProductFragment on Product {
    id
    name
    description
    price
    image
    sku
    variants
    type
    category
    meta
  }
`;
